module.exports = __webpack_public_path__ + "img/logo.bed80fc7.png";